
$(document).on('click', '.jdgm-widget', function (e) {
  e.preventDefault();
  setTimeout(function () {
    var target = document.querySelector('.jdgm-title');
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
    setTimeout(function () {
      var newTop = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: newTop,
        behavior: 'smooth'
      });
    }, 600);

  }, 100);
});


$(document).on(
  'click',
  '.promo-hero-cta.secondary[href="#gbq-template--27833990250589__gb_quote_hub_fj3hGw"]',
  function (e) {

    e.preventDefault();

    setTimeout(function () {

      var target = document.querySelector(
        '#gbq-template--27833990250589__gb_quote_hub_fj3hGw'
      );

      if (!target) return;

      var top = target.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });

      setTimeout(function () {

        var newTop =
          target.getBoundingClientRect().top +
          window.pageYOffset;

        window.scrollTo({
          top: newTop,
          behavior: 'smooth'
        });

      }, 600);

    }, 100);

  }
);

$(document).on(
  'click',
  '.sc-cta-button.secondary[href="#gbq-template--27833990250589__gb_quote_hub_fj3hGw"], .gb-banner-link',
  function (e) {

    e.preventDefault();

    setTimeout(function () {

      var target = document.querySelector(
        '#gbq-template--27833990250589__gb_quote_hub_fj3hGw'
      );

      if (!target) return;

      var top = target.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });

      setTimeout(function () {

        var newTop =
          target.getBoundingClientRect().top +
          window.pageYOffset;

        window.scrollTo({
          top: newTop,
          behavior: 'smooth'
        });

      }, 600);

    }, 100);

  }
);


$(document).ready(function () {
  
   $('.faq-question').click(function () {
      var $item = $(this).parent('.faq-item');
      $('.faq-item').not($item).removeClass('active');
      $('.faq-answer-wrap').not($item.find('.faq-answer-wrap')).slideUp(250);
      $item.toggleClass('active');
      $item.find('.faq-answer-wrap').slideToggle(250);
    });

  var $slider = $('#pcs-track');
  function initSlider() {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              dots: true,
              centerMode: false,
              variableWidth: false
            }
          }
        ]
      });
    }
  }

  initSlider();
  // Resize
  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      initSlider();
    }, 250);
  });

  // Slider
  $('.vt-slider').slick({
    slidesToShow: 4,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      { breakpoint: 990, settings: { slidesToShow: 2, arrows: false, dots: true } },
      { breakpoint: 750, settings: { slidesToShow: 1, arrows: false, dots: true } }
    ]
  });
  // Open video popup
  $('.vt-thumb').on('click', function() {
    var url = $(this).data('video');
    var yt = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([a-zA-Z0-9_-]{11})/);
    var player = yt
      ? '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&playsinline=1" allow="autoplay" allowfullscreen></iframe>'
      : '<video src="' + url + '" controls autoplay playsinline></video>';
    $('.vt-modal-box').html(player);
    $('.vt-modal').addClass('open');
  });
  //  Close video popup
  $('.vt-close, .vt-modal').on('click', function(e) {
    if (e.target === this) {
      $('.vt-modal').removeClass('open').find('.vt-modal-box').empty();
    }
  });

});